import { FC, useState } from "react";
import { Outlet } from "react-router-dom";
import { Flex } from "@chakra-ui/react";
import { useLayoutConfig } from "~/hooks/useLayoutConfig";
import { useLocationType } from "~/hooks/useLocationType";
import { OutletContextType } from "~/hooks/usePageIsLoading";
import { Footer } from "./Footer";
import { FullBleedSection } from "./FullBleedSection";
import { Header } from "./Header";

export const Layout: FC = () => {
  const { hasHeader, hasFooter } = useLayoutConfig();
  const locationType = useLocationType();
  const [isPageLoading, setIsPageLoading] = useState(true);
  const outletContext: OutletContextType = { isPageLoading, setIsPageLoading };

  return (
    <Flex align="center" direction="column" minH="100vh" w="100%">
      {hasHeader && <Header />}
      {locationType === "landingApp" ? (
        <Flex align="center" as="main" direction="column" flexGrow={1} w="100%">
          <Outlet context={outletContext} />
        </Flex>
      ) : (
        <FullBleedSection
          bg="bg-main-accent"
          bgSize="cover"
          flexGrow={1}
          justify="flex-start"
        >
          <Flex as="main" flexGrow={1} w="100%">
            <Outlet context={outletContext} />
          </Flex>
        </FullBleedSection>
      )}
      {!isPageLoading && hasFooter && <Footer />}
    </Flex>
  );
};
